export default __webpack_public_path__ + "static/media/pitch-tracking-animation.f0c5c36c.GIF";